import { ChangeDetectorRef, Component, ElementRef, Injectable, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CampaignService } from 'app/common/services/Campaign.service';
import { ServiceService } from 'app/common/services/Service.service';
import * as _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { ToastrService } from 'ngx-toastr';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { CommentService } from '../../../../common/services/Comment.service';
import { CommonService } from '../../../../common/services/Common.service';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { FieldService } from '../../../../common/services/Field.service';
import { GroupService } from '../../../../common/services/Group.service';
import { OrganizeService } from '../../../../common/services/Organize.service';
import { SearchService } from '../../../../common/services/Search.service';
import { SocketService } from '../../../../common/services/Socket.service';
import { TicketService } from '../../../../common/services/Ticket.service';
import { UploadService } from '../../../../common/services/Upload.service';
import { UserService } from '../../../../common/services/User.service';
import { AssignList, AssignListAgent, AssignType, ExtendAssign, getParams, SearchConst } from './search.const';
import { UserSharedService } from '../customer/UserSharedService';
import { SettingTabList } from '../setting/setting.const';
import { PriorityService } from '../../../../common/services/Priority.service';
import { TicketTypeService } from '../../../../common/services/TicketType.service';
import { Role } from '../setting/expert/expert.const';
import { BaseListComponent } from '../../../../components/base-list.component';
import { CommonSettingsService } from '../../../../common/share-data/common.setting.service';
import { SharedUserService } from '../../../../common/share-data/user.service';

@Component({
  moduleId: module.id,
  selector: 'search',
  templateUrl: './search.component.html',
  styleUrls: ['../../../../../css/fuck.css', './search.css', './ticket-search.module.css'],
  providers: [
    UserService,
    TicketService,
    EvsAddressService,
    OrganizeService,
    GroupService,
    FieldService,
    SearchService,
    CommentService,
    UploadService,
    CommonService,
    CampaignService,
    ServiceService,
    PriorityService,
    TicketTypeService,
  ],
})
@Injectable()
export class SearchComponent extends BaseListComponent {
  @ViewChild('templateFilter') templateFilter: ElementRef;
  public exportFields: any = [];
  public filterSearchKey = 'search_user';
  public assignType = AssignType.All;
  public assignList = [];
  public active_fields: any = [];
  public data_search: any = {};
  public displayFilter = false;
  public choice: any = {};
  public modelFilter: any = {};
  public allType: any = [{ id: '', text: '' }];
  public allPriority: any = [{ id: '', text: '' }];
  public allAgent: any = [];
  public allCampaign: any = [];
  public allStatus: any = [];
  public allCity: any = [];
  public allGroup: any = [];
  public allOrganize: any = [];
  public tab = 'ticket';
  public placeholder = 'Tìm kiếm theo từ khóa';
  public detailTicket: any = {};
  public listFilter: any = [];
  public selectFilter: any = 'Bộ lọc mới';
  public filterHtml: any = {};
  public filterModal: any = {};
  public editFilterId: any;
  public filter: any = [{}];

  /************IMPORT */
  public step = 1;
  public file_out: any;
  public keys: any = [];
  public fieldsImport: any = [];
  public modelImport: any = {};
  public headers: any = [{ id: '', text: '' }];
  public mapping: any = {};
  public file_import: any;
  public key: any;
  public exec_import: any = 'create';
  public current_job: any = {};
  public complete_load = 50;
  public userLogin: any = {};
  public cancel_import = false;
  public isExpand = false;
  public displayFilterForm = false;
  public allSources = [
    { id: 'all', text: '- Tất cả -' },
    { id: 'CALL_OUTBOUND', text: 'Gọi điện ra' },
    { id: 'CALL_INBOUND', text: 'Khách gọi điện' },
    { id: 'chat', text: 'Tin nhắn web' },
    { id: 'hand', text: 'Thêm mới' },
    { id: 'zalo', text: 'Zalo' },
    { id: 'email', text: 'Email' },
    { id: 'facebook', text: 'Kênh Facebook' },
  ];
  @ViewChild('keyword') searchBox: ElementRef;
  /************IMPORT */

  public is_updated = false;
  public data_updated = [];
  public ticketFields: any = [];
  public allOrganizeData: any = [];
  protected readonly settingTabList = SettingTabList;
  private customParams: any = {};
  public allService: any = [];
  public serviceParentMax: any = [];

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private userService: UserService,
    private ticketService: TicketService,
    private searchService: SearchService,
    private socketService: SocketService,
    private route: ActivatedRoute,
    private priorityService: PriorityService,
    private typeService: TicketTypeService,
    private sharedService: UserSharedService,
    private sharedCommonSettings: CommonSettingsService,
    private sharedUserService: SharedUserService,
    private commonService: CommonService
  ) {
    super(changeDetector, toastr, modalService);
    if (this.user.role == Role.Agent) {
      this.assignList = AssignListAgent.map(e => {
        if (e.id == AssignType.All) {
          e.title = 'Ticket của tôi';
        }
        return e;
      });
    } else {
      this.assignList = [...AssignList];
    }

    if (this.user.role === Role.TeamLeader) {
      this.assignList = this.assignList
        .filter(item => item.id !== AssignType.InGroup)
        .map(e => {
          if (e.id == AssignType.All) {
            e.title = 'Thuộc bộ phận của tôi';
          }
          return e;
        });
    }

    if (this.user.role == Role.Administrator) {
      this.assignList = this.assignList
        .filter(item => item.id !== AssignType.InGroup)
        .map(e => {
          if (e.id == AssignType.All) {
            e.title = 'Tất cả';
          }
          return e;
        });
    }

    this.sharedService.onTicketUpdate.subscribe(data => {
      let updated_data = this.data;
      const exits = _.find(updated_data, { _id: data._id });
      if (exits) {
        updated_data = updated_data.filter(d => d._id != data._id);
        exits.subject = data.subject;
        exits.updated_at = data.updated_at;
        exits.assign_agent_id = data.assign_agent_id;
        exits.status = data.status;
        exits.display_subject = SearchConst.displaySubjectColumns(exits, this.user);
        exits.display_assignee = SearchConst.displayAssigneeColumns(exits, this.allAgent);
        exits.display_status = SearchConst.displayStatusColumns(exits);
        exits.display_updated_at = SearchConst.displayTimeColumns(exits.updated_at);
        updated_data = [exits, ...updated_data];
      }
      this.is_updated = true;
      this.data_updated = updated_data;
    });
  }

  private _filterChecked: any = null;

  public get filterChecked() {
    return this._filterChecked ? this._filterChecked._id : null;
  }

  public set filterChecked(value) {
    this._filterChecked = this.filterChecked === value._id ? null : value;
    this.choiceFilter(this._filterChecked);
  }

  // tslint:disable-next-line:use-life-cycle-interface
  async ngOnInit() {
    this.is_loading = true;
    this.allOrganizeData = await this.sharedCommonSettings.getAllOrganize();
    this.allPriority = await this.sharedCommonSettings.getAllPriority();
    this.allType = await this.sharedCommonSettings.getAllType();
    await this.getStatus();
    await this.getServices();
    await this.getAllAgent();
    await this.loadTicketFields();
    await this.getAllCampaign();
    await this.loadFilter();
    // @ts-ignore
    const { ticket_table_columns } = (await this.sharedCommonSettings.getUserConfig()) || {};
    const displayColumns = SearchConst.displayColumns(this.ticketFields, this.serviceParentMax);
    if (ticket_table_columns) {
      const saveDisplayColumns = JSON.parse(ticket_table_columns);
      this.displayColumns = displayColumns.map(d => {
        try {
          const sD = saveDisplayColumns.find(sd => d.field === sd.field);
          if (sD) {
            d.display = sD.display;
          }
          return d;
        } catch (e) {
          return d;
        }
      });
    } else {
      this.displayColumns = displayColumns;
      await this.commonService
        .settingUserConfig({
          user_id: this.user._id,
          ticket_table_columns: JSON.stringify(this.displayColumns),
        })
        .toPromise();
    }
    this.exportFields = this.displayColumns.filter(f => f.display === true).map(f => f.field);
    this.modelFilter['source'] = 'all';
    if (this.route.snapshot.queryParamMap.get('tab')) {
      this.changeTab(this.route.snapshot.queryParamMap.get('tab'));
    }
    this.keys = [
      { id: '', text: '' },
      { id: 'phone', text: 'Điện thoại' },
      { id: 'email', text: 'Email' },
    ];

    this.fieldsImport = [
      { key: 'name', title: 'Tên' },
      { key: 'phone', title: 'Điện thoại' },
      { key: 'email', title: 'Email' },
      { key: 'address', title: 'Địa chỉ', type: 'text' },
      { key: 'facebook', title: 'Facebook' },
      { key: 'gender', title: 'Giới tính' },
      { key: 'note', title: 'Ghi chú' },
    ];
    await this.loadData();

    fromEvent(this.searchBox.nativeElement, 'change')
      .debounceTime(1000)
      .distinctUntilChanged()
      .subscribe(() => {
        this.loadData(true);
      });
  }

  async getServices() {
    this.allService = await this.sharedCommonSettings.getAllService();
    const countMax = this.countLevels(this.allService);
    for (let i = 0; i < countMax; i++) {
      this.serviceParentMax.push({
        title: 'Nhóm dịch vụ cấp ' + (i + 1),
        key: i === 0 ? 'service_id' : 'service_id' + i,
        field: i === 0 ? 'service_id' : 'service_id' + i,
      });
    }
  }

  countLevels(data) {
    let maxLevel = 0;
    const findLevel = (item, currentLevel) => {
      const parent = data.find(d => d.id === item.parent_id);
      if (parent) {
        return findLevel(parent, currentLevel + 1);
      }
      return currentLevel;
    };

    data.forEach(item => {
      const level = findLevel(item, 1);
      if (level > maxLevel) {
        maxLevel = level;
      }
    });

    return maxLevel;
  }

  async changedOptionView(data) {
    this.displayColumns = data;
    await this.commonService
      .settingUserConfig({
        user_id: this.user._id,
        ticket_table_columns: JSON.stringify(this.displayColumns),
      })
      .toPromise();
    this.exportFields = this.displayColumns.filter(f => f.display === true).map(f => f.field);
  }

  async loadTicketFields() {
    const res = await this.sharedCommonSettings.getAllTicketFields();
    res.forEach(e => {
      this.ticketFields.push({
        key: e.key,
        title: e.title,
        type: e.type,
      });
    });
  }

  expandFilter() {
    if (!this.isExpand) {
      if (this.user.role === Role.Agent) {
        this.assignList = [...AssignListAgent, ...ExtendAssign].filter(e => e.id !== AssignType.Completed);
      } else {
        if (this.user.role === Role.TeamLeader) {
          this.assignList = [...AssignList, ...ExtendAssign];
        } else {
          this.assignList = [
            ...AssignList,
            ...ExtendAssign,
            {
              id: AssignType.NotTag,
              title: 'Ticket chưa được gán',
            },
          ];
        }
      }
    } else {
      if (this.user.role === Role.Agent) {
        this.assignList = this.assignList.filter(item => AssignListAgent.some(extend => extend.id === item.id));
      } else {
        this.assignList = this.assignList.filter(item => AssignList.some(extend => extend.id === item.id));
      }
      if (!this.assignList.find(r => r.id === this.assignType)) {
        this.assignType = this.assignList[0].id;
        this.loadData(false).then();
      }
    }
    if (this.user.role == Role.TeamLeader) {
      this.assignList = this.assignList.filter(item => item.id !== AssignType.InGroup);
    }
    this.isExpand = !this.isExpand;
  }

  getPriorities() {
    return this.priorityService.allPriority().map(res => {
      const priorityList = [];
      res.data.forEach((c: any) => {
        priorityList.push({
          text: c.name,
          id: c.id,
        });
      });
      this.allPriority = priorityList;
    });
  }

  getTypes() {
    return this.typeService.allTicketType().map(res => {
      const typeList = [];
      res.data.forEach((c: any) => {
        typeList.push({
          text: c.name,
          id: c.id,
        });
      });
      this.allType = typeList;
    });
  }

  onChangeAssign(assingType: AssignType) {
    this.assignType = assingType;
    this.loadData(true);
  }

  changeSource(e: any): void {
    if (this.modelFilter['source'] != e.value) {
      if (e.value == 'all') {
        e.value = '';
      }
      this.modelFilter['source'] = e.value;
    }
    this.loadFilter();
    this.loadData();
  }

  choiceFilter(filter?: any) {
    this.selectFilter = 'Bộ lọc mới';
    this.editFilterId = null;
    if (filter) {
      this.selectFilter = filter.name;
      this.filterHtml = JSON.parse(filter.data);
      this.filterModal = {
        main_and_or: filter.main_and_or,
        sub_and_or: filter.sub_and_or,
      };
    } else {
      this.filterHtml = {};
      this.filterModal = {};
    }
  }

  selectedFilter(filter, event) {
    event.stopPropagation();

    if (filter) {
      this.editFilterId = filter._id;
    }
  }

  deleteFilter(filter: any, event) {
    event.stopPropagation();

    const y = confirm('Bạn có muốn xóa bộ lọc này không?');
    if (y) {
      this.searchService.deleteFilter(filter._id).subscribe(res => {
        if (res.status == 200 && !res.error) {
          this.loadFilter();
          this.toastr.success('Xóa bộ lọc thành công', '', {
            timeOut: 4000,
            positionClass: 'toast-bottom-right',
          });
          if (this.editFilterId === filter._id) {
            this.editFilterId = null;
          }
        }
      });
    }
  }

  cancel() {
    this.displayFilterForm = false;
    this.editFilterId = null;
  }

  sort(value) {
    this.customParams = {
      ...this.customParams,
      sort_by: `${value.key}:${value.type}`,
    };

    this.loadData(true);
  }

  openFilterModal() {
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'model-md',
    };
    this.openModal(this.templateFilter, config);
  }

  openModalImport(template: TemplateRef<any>) {
    this.message = null;
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    };
    this.modalRef2 = this.modalService.show(template, config);
    this.modelImport = {};
    this.file_import = null;
    this.key = null;
    this.step = 1;
    this.file_out = null;
    this.mapping = {};
  }

  changeTab(tab) {
    if (tab != this.tab) {
      this.model = {
        sub_and_or: 'and',
        main_and_or: 'and',
      };
      this.currentPage = 1;
      this.totalItem = 0;
      this.totalPage = 0;
      this.data = [];
      this.tab = tab;
      this.loadData();
      this.loadFilter();
      this.selectFilter = 'Bộ lọc mới';
      this.editFilterId = null;
    }
  }

  toggleFilter() {
    this.displayFilter = !this.displayFilter;
  }
  async buildPayload(customField = {}) {
    const data = this.data_search;
    let active_fields = this.active_fields;
    let condition = {};
    const arr = [];
    active_fields = _.union(active_fields);
    active_fields.forEach(field => {
      const sub_condition = {};
      if (this.model.sub_and_or == 'and') {
        sub_condition['must'] = data[field];
      } else {
        sub_condition['should'] = data[field];
      }
      arr.push({
        bool: sub_condition,
      });
    });
    if (arr.length > 0) {
      if (this.model.main_and_or == 'and') {
        condition['must'] = arr;
      } else {
        condition['should'] = arr;
      }
    } else {
      condition = {};
    }
    const fill = [];
    let inputParameters = {};
    if (this.modelFilter['source'] && this.modelFilter['source'] != 'all') {
      fill.push({
        key: 'source_detail',
        condition: '=',
        value: this.modelFilter['source'],
      });
    }

    const body = {
      data_fields: data,
      condition: JSON.stringify(condition),
      active_fields: JSON.stringify(active_fields),
      type: this.tab,
      label: this.model.main_and_or,
      sub_label: this.model.sub_and_or,
      keyword: this.model.keyword ? this.model.keyword.trim() : '',
      force_search: 'customer',
      ...customField,
    };
    body['offset'] = this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    body['limit'] = this.page_size;
    // update filter
    const params = {
      filter: '',
      offset: this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1),
      limit: this.page_size,
      sort_by: 'updated_at:desc',
      source: getParams(this.assignType),
      keyFilter: this.assignType == AssignType.Campaign ? 'campaign' : 'all',
      ...this.customParams,
    };
    if (this.model.keyword) {
      fill.push({
        key: 'subject',
        condition: '=',
        value: this.model.keyword ? this.model.keyword.trim() : '',
      });
    }
    switch (this.assignType) {
      case AssignType.MissedCall:
        fill.push({ key: 'call_status', condition: '=', value: 'miss' });
        params.filter = JSON.stringify(fill);
        inputParameters = params;
        break;
      case AssignType.NotTag:
        fill.push(
          { key: 'assign_agent_id', condition: '=', value: null },
          { key: 'status', condition: 'nin', value: [] }
        );
        params.filter = JSON.stringify(fill);
        inputParameters = params;
        break;
      case AssignType.Open:
        fill.push({ key: 'status', condition: 'in', value: [1, 2, 4] });
        params.filter = JSON.stringify(fill);
        inputParameters = params;
        break;
      case AssignType.InProcess:
        fill.push({ key: 'status', condition: '=', value: 2 });
        params.filter = JSON.stringify(fill);
        inputParameters = params;
        break;
      case AssignType.Completed:
        fill.push({ key: 'status', condition: '=', value: 5 });
        params.filter = JSON.stringify(fill);
        inputParameters = params;
        break;
      case AssignType.Campaign:
        break;
      case AssignType.NearExpired:
        const date1 = new Date();
        date1.setDate(date1.getDate() + 1);
        fill.push(
          {
            key: 'duedate',
            condition: 'lt',
            value: moment(date1).format('YYYY-MM-DD') + 'T23:59:59.999Z',
          },
          {
            key: 'duedate',
            condition: 'gt',
            value: moment(new Date()).format('YYYY-MM-DD') + 'T00:00:00.000Z',
          },
          { key: 'status', condition: 'in', value: [1, 2, 4] }
        );
        params.filter = JSON.stringify(fill);
        inputParameters = params;
        break;
      default:
        if (this.modelFilter && this.modelFilter['source'] && this.modelFilter['source'] != 'all') {
          active_fields = ['source_detail'];
          condition['must'] = [
            {
              bool: {
                must: [
                  {
                    match: {
                      source_detail: this.modelFilter['source'],
                    },
                  },
                ],
              },
            },
          ];
          body['active_fields'] = JSON.stringify(active_fields);
          body['condition'] = JSON.stringify(condition);
          inputParameters = params;
        }
        break;
    }
    if (this.assignType == AssignType.Campaign) {
      fill.push(
        { key: 'assign_agent_id', condition: '=', value: this.user._id },
        { key: 'status', condition: 'nin', value: [] }
      );
      params.filter = JSON.stringify(fill);
      inputParameters = params;
      return [body, inputParameters];
    } else {
      params.filter = JSON.stringify(fill);
      inputParameters = params;
      return [body, inputParameters];
    }
  }

  async loadData(isSearch = false, customField = {}) {
    this.is_updated = false;
    this.data = [];
    if (isSearch) {
      this.currentPage = 1;
    }

    const [body, inputParameters] = await this.buildPayload(customField);
    await this.fetchData(body, inputParameters);
  }

  async fetchData(body, inputParameters) {
    await this.searchService.all(body, inputParameters, this.assignType).subscribe(res => {
      if (!res.error && res.status == 200) {
        this.data = res.data.res.list;
        if (this.tab == 'user') {
          this.data = _.map(this.data, e => {
            if (e.group_id) {
              const group = _.find(this.allGroup, {
                id: parseInt(e.group_id),
              });
              if (group) {
                e['group'] = group;
              }
            }
            if (e.organize_id) {
              const org = _.find(this.allOrganize, {
                id: parseInt(e.organize_id),
              });
              if (org) {
                e['organize'] = org;
              }
            }
            if (e.city_id) {
              const city = _.find(this.allCity, { id: parseInt(e.city_id) });
              if (city) {
                e['city'] = city;
              }
            }
            return e;
          });
        } else if (this.tab == 'organize') {
          this.data = _.map(this.data, e => {
            if (e.tags) {
              e.tags = e.tags.split(','); // split để hiển thị trên table
            }
            return e;
          });
        }

        this.data = _.map(this.data, e => {
          e.display_follow_users = SearchConst.displayUsersColumns(e.follow_users, this.allAgent);
          e.display_cc_users = SearchConst.displayUsersColumns(e.cc_users, this.allAgent);
          e.display_organization = SearchConst.displayOrganizationColumns(e, this.allOrganizeData);
          e.display_code = SearchConst.displayCodeColumns(e);
          e.display_requester = SearchConst.displayRequesterColumns(e.request, this.user);
          e.display_subject = SearchConst.displaySubjectColumns(e, this.user);
          e.display_assignee = SearchConst.displayAssigneeColumns(e, this.allAgent);
          e.display_source = SearchConst.displaySourceColumns(e);
          e.display_status = SearchConst.displayStatusColumns(e);
          e.display_created_at = SearchConst.displayTimeColumns(e.created_at);
          e.display_updated_at = SearchConst.displayTimeColumns(e.updated_at);
          e.display_priority = SearchConst.displayPriorityColumns(e.priority_id, this.allPriority);
          e.display_type = SearchConst.displayTypeColumns(e.type_id, this.allType);
          e.display_duedate = SearchConst.displayTimeColumns(e.duedate);
          this.ticketFields.forEach(t => {
            e['display_' + t.key] = SearchConst.displayFieldColumn(e, t);
          });
          if (e.service_id) {
            let serviceKeys = Object.keys(e).filter(key => key.startsWith('service_id'));
            serviceKeys.forEach((key, index) => {
              const keys = key.replace('service_id', 'display_service_id');
              e[keys] = SearchConst.displayServiceColumns(e[key], this.allService);
            });
          }
          return e;
        });
        this.totalItem = res.data.res.total;
        const pageString = (this.totalItem / this.page_size).toString();
        const pageSplit = pageString.split('.');
        let last: any;
        let totalpage = parseInt(pageSplit[0]);
        if (pageSplit.length > 1) {
          last = pageSplit[1];
          if (parseInt(last) > 0) {
            totalpage++;
          }
        }
        this.totalPage = totalpage;
      }
    });
  }

  async getStatus() {
    const res = await this.sharedCommonSettings.getAllStatus();
    const statusList = [];
    res.forEach((c: any) => {
      statusList.push({
        text: c.name,
        id: c.id,
      });
    });
    this.allStatus = statusList;
  }

  async getAllAgent() {
    const res = await this.sharedUserService.getAllUsers();
    const agentList = [];
    res.forEach((c: any) => {
      agentList.push({
        text: c.name,
        id: c._id,
      });
    });
    this.allAgent = agentList;
  }

  async getAllCampaign() {
    const res = await this.sharedCommonSettings.getAllCampaign();
    const campaignList = [];
    res.forEach((c: any) => {
      campaignList.push({
        text: c.name,
        id: c._id,
      });
    });
    this.allCampaign = campaignList;
  }

  async loadFilter() {
    this.searchService.listFilter({ type: 'ticket' }).subscribe(res => {
      if (res.status == 200 && !res.error) {
        this.listFilter = res.data.data;
      }
    });
  }

  openTicket(ticket: any) {
    this.ticketService.find(ticket._id).subscribe(rs => {
      const _ticket = rs.data;
      _ticket['_id'] = ticket._id;
      this.userService
        .find({ _id: ticket.requester_id })
        .toPromise()
        .then(res => {
          if (res.status == 200 && res.error == false) {
            _ticket.request = res.data;
            this.socketService.opentab(_ticket, 'ticket', 'edit');
          }
        });
    });
  }

  loadDataByFilter(data) {
    this.model.main_and_or = data.main_and_or || 'and';
    this.model.sub_and_or = data.sub_and_or || 'and';
    this.data_search = data.data_search || {};
    this.active_fields = data.active_fields || [];
    this.loadData(true);
  }

  onSaveFilter(data) {
    const payload = {
      data: JSON.stringify(data.data_save),
      main_and_or: data.main_and_or,
      sub_and_or: data.sub_and_or,
      name: data.name,
      type: 'ticket',
      type_filter: 'search_ticket',
    };
    if (!payload.name || (payload.name && payload.name.trim() === '')) {
      this.message = {
        class: 'alert dark alert-danger',
        content: 'Tên bộ lọc không được bỏ trống!',
      };
      return;
    }
    this.searchService.createFilter(payload).subscribe(
      res => {
        if (!res.error && res.status == 200) {
          this.throwSuccess('Thêm mới thành công!');
          this.loadFilter();
          this.choiceFilter(res.data);
          this.filterChecked = res.data;
          this.closeModal();
        } else {
          this.throwError(res.message);
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }
  endLoading() {
    this.is_loading = false;
  }
  async export() {
    const [body, inputParameters] = await this.buildPayload({});
    await this.ticketService.exports(inputParameters, { ...body, fields: this.exportFields });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/search/search.component.ts